import { CombinedDatepickerRangeOutput, ListRange, SearchCriteriaBase } from '../../../../../common/models';
import { ListQueryParam } from '../../../../../common/constants/list-query-param.constant';
import { DataQualityErrorMessage } from '../../message-checker';

export class Sc4FailedMessagesModel {
  transactionNumber: string;
  transactionDateTime: number;
  carrierTO: string;
  carrierId: string;
  rawMessageId: number;
  errors: DataQualityErrorMessage;
}

export class Sc4FailedMessagesListSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.TransactionDateTime]: CombinedDatepickerRangeOutput;
  [ListQueryParam.CarrierId]: string[];
  [ListQueryParam.TransportReferences]: string[];

  constructor(params?: Partial<Sc4FailedMessagesListSearchCriteria> | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
